module.exports = __webpack_public_path__ + "img/statistics.2283d607.svg";